/* eslint-disable indent */
/* eslint-disable react-hooks/exhaustive-deps */
import { MinusCircleOutlined, PlusOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { Modal, Form, Input, Button, Space, Tooltip } from "antd";
import { useEffect } from "react";

const ContestExclusionManagerModal = ({
  isVisible = false,
  onCancel = () => {},
  onSave = () => {},
  initialPatterns = [],
  isLoading = false
}) => {
  const [form] = Form.useForm();

  const handleSave = async () => {
    const values = await form.validateFields();
    onSave(values.patterns);
  };

  useEffect(() => {
    form.setFieldsValue({ patterns: initialPatterns });
  }, [initialPatterns]);

  return (
    <Modal
      title={
        <Space>
          Manage Contest Exclusion Patterns
          <Tooltip
            title={
              <>
                <b>Tip:</b> To get the correct regex pattern format, you can ask AI like:
                <br />
                <i>
                  “Given the following contest names: <b>&lt;list of contest names&gt;</b>, generate
                  backend exclusion regex patterns that generalize any numeric parts using{" "}
                  <code>\d+</code>. Output only the regex patterns, one per line, in the format:{" "}
                  <code>^pattern$</code>. No slashes or flags.”
                </i>
                <br />
                <br />
                Expected format examples:
                <br />
                <code>^weekend dev challenge \d+: full stack projects using mern$</code>
                <br />
                (No slashes or flags — those go in the <b>flags</b> field separately)
              </>
            }
            placement="right"
          >
            <InfoCircleOutlined style={{ color: "var(--text-secondary)", cursor: "pointer" }} />
          </Tooltip>
        </Space>
      }
      open={isVisible}
      onCancel={onCancel}
      onOk={handleSave}
      confirmLoading={isLoading}
      destroyOnClose
      centered
    >
      <Form layout="vertical" form={form}>
        <Form.List name="patterns">
          {(fields, { add, remove }) => (
            <>
              {fields.map(({ key, name }) => (
                <Space
                  key={key}
                  style={{ display: "flex", flexWrap: "wrap", marginBottom: 8 }}
                  align="baseline"
                >
                  <Form.Item name={[name, "pattern"]} rules={[{ required: true }]}>
                    <Input placeholder="regex pattern" />
                  </Form.Item>

                  <Form.Item name={[name, "flags"]} initialValue="i">
                    <Input placeholder="flags" style={{ width: "min(60px, 100%)" }} />
                  </Form.Item>

                  <MinusCircleOutlined onClick={() => remove(name)} />
                </Space>
              ))}
              <Form.Item>
                <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                  Add Pattern
                </Button>
              </Form.Item>
            </>
          )}
        </Form.List>
      </Form>
    </Modal>
  );
};

export default ContestExclusionManagerModal;
